import { Translations } from '@lib/dictionary-keys/__generated__';
import { SponsorCardImagePosition } from '@stadionhq-v3/base-ui';
import { CleanedContentfulImageProps } from '@stadionhq-v3/clean-contentful';
import { ContentfulImage } from '@stadionhq-v3/contentful-ui';

type BuildUpHeaderBlockWrapperTransformTranslations = {
  sponsoredBy?: Translations['common']['label']['sponsoredBy'];
};

const buildUpHeaderBlockWrapperTransform = ({
  title,
  sponsor,
  dictionary,
}: {
  title?: string;
  sponsor?: CleanedContentfulImageProps;
  dictionary: BuildUpHeaderBlockWrapperTransformTranslations;
}) => ({
  title: title || undefined,
  sponsor: sponsor
    ? {
        image: <ContentfulImage {...sponsor} />,
        title: dictionary?.sponsoredBy,
        imagePosition: 'right' as SponsorCardImagePosition,
        onDark: false,
      }
    : undefined,
  onDark: false,
});

export default buildUpHeaderBlockWrapperTransform;
